import React from "react"
import { withStyles, WithStyles, createStyles } from "@material-ui/core"

import Item, { BaseProps } from "../../../../../../Links/Item"
import Button from "./Button"

const styles = () => {
  return createStyles({
    root: {
      "& + &": {
        marginTop: "0.5rem",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles>, BaseProps {}

function FooterItem(props: Props) {
  return <Item Button={Button} {...props}></Item>
}

export default withStyles(styles)(FooterItem)
